<template>
  <picture>
    <source
      v-if="imageMobile"
      :data-srcset="imageMobile.url"
      :media="'(max-width: ' + breakpoint + 'px)'" />
    <img
      :data-src="image.url"
      class="lazyload object-fit-cover"
      :alt="image.alt" />
  </picture>
</template>

<script>
import mixins from '../../mixins/mixins'

export default {
  mixins: [mixins],
  props: {
    image: {
      required: false,
      type: Object,
      default: null,
    },
    imageMobile: {
      required: false,
      type: Object,
      default: null,
    },
    breakpoint: {
      required: false,
      type: Number,
      default: 767,
    },
  },
}
</script>
